const standardPatterns = {
    socialSecurityNumber: { pattern: `\\d{2} ?\\d{6} ?[A-Za-z] ?\\d{3}`, placeholder: "z.B.: 15 070649 C 103" },
    taxId: { pattern: `\\d{11}`, placeholder: "Elfstellig, nur Zahlen" },
    postalCode: `^\\d{5}$`,
    companyNumber: `^\\d{8}$`,
    clientNumber: `^\\d*$`,
    consultantNumber: `^\\d*$`,
    phone_number: `^\\+?[0-9 ()/.-]{7,30}$`,
    city_pattern: `^[\\p{L}\\s'.-]{2,100}$`,
};
export const patterns = {
    DE: standardPatterns,
    AT: {
        ...standardPatterns,
        socialSecurityNumber: { pattern: `\\d{4} ?\\d{6}`, placeholder: "z.B. 1234 301192" },
        taxId: { pattern: `\\d{9}`, placeholder: "Neunstellig, nur Zahlen" },
        postalCode: `^\\d{4}$`,
    },
};
//# sourceMappingURL=validation.js.map